import React, { Component } from 'react';
import { QueryRenderer } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Link, Paper, TableContainer, Table, TableHead, TableCell, TableBody, TableRow, Typography } from '@mui/material';
import Add from '@mui/icons-material/Add';

import { TablePagination } from '@mui/material';
import ServerError from '../ui/ServerError';
import TabPageTitle from '../ui/TabPageTitle';
import LoadingSpinner from '../ui/LoadingSpinner';
import EnvironmentDefs from '../../EnvironmentDefs';
import AppLogo from '../ui/AppLogo';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();
const envDefs = new EnvironmentDefs();

const LandingPageSearchQuery = graphql`
query LandingPageSearchQuery($accountId: UUID!, $first: Int, $offset: Int) {
  allAccountLandingTs(first: $first, offset: $offset, condition:{accountId: $accountId} orderBy:LANDING_PATH_ASC) {
    totalCount
    nodes {
      accountTByAccountId {
        logo
        accountPath
      }
      accountLandingId
      landingPath
      landingName
      landingText
      logo
      landingTitle  
    }	
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.background.default,
  },
  flex: {
    flex: 1,
  },
  paper: {
    maxWidth: 980,
    marginTop: '32px'
  },
  button: {
    marginTop: 15,
    marginRight: 16,
  },
  appLogo: {
    float: 'left',
    marginRight: 15
  },
  landingLink: {
    marginTop: 18
  }
});

class LandingPageSearch extends Component {
  state = {
    page: 0,
    rowsPerPage: 10
  };

  
  goTo(route) {
 
    this.props.history.push(`/${route}`);
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }
  
  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page: 0});
  }

  render() {
    const { isAuthenticated, isAuthenticatedVendor, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;
 
    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;

    let totalCount = 0;

    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    } else if (isAuthenticatedVendor()) {
      return (
        <main>
          <TabPageTitle title="Sign up links" subtitle="Set up marketing landing pages and sign up links."/>

          <Grid container spacing={1} direction="row" justifyContent="flex-start">
             <Grid item>
             <Button
                color="primary"
                variant="contained"
                style={AppBindStyles.addButtonOnSearch}
                onClick={() => {this.goTo('landingpagecreate');}}>
                <Add/> Sign up link
              </Button>
            </Grid>
          </Grid>

          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={LandingPageSearchQuery}
            variables={{accountId: abEnvironment.getUserAttribute('a_id'),
                        first: first,
                        offset: offset}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                // Determine offset information
                totalCount = props.allAccountLandingTs.totalCount;

                let landingPages = props.allAccountLandingTs.nodes;
 
                return ( 
                  <div className={classes.paper}>

                    <Paper >
                      <TableContainer>
                        <Table>
                          <TableHead style={AppBindStyles.tableHead}>
                            <TableRow style={AppBindStyles.tableHeadRow}>
                              <TableCell>Sign up link</TableCell>
                              <TableCell>Sign up URL</TableCell>
                              <TableCell>Register URL (existing accounts)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {landingPages.map(n => {

                              let accountPath = n.accountTByAccountId.accountPath;

                              let aUrl = "landingpageedit?accountLandingId=" + n.accountLandingId
                              let landingUrl = '';
                              if ((envDefs.getEnv() === "poc" || envDefs.getEnv() === "devpoc")) {
                                landingUrl = "https://poc.appbind.com/signup/" + accountPath + "/" + n.landingPath;
                              } else {
                                landingUrl = "https://app.appbind.com/signup/" + accountPath + "/" + n.landingPath;
                              }

                              let registerUrl = '';
                              if ((envDefs.getEnv() === "poc" || envDefs.getEnv() === "devpoc")) {
                                registerUrl = "https://poc.appbind.com/register/" + accountPath + "/" + n.landingPath;
                              } else {
                                registerUrl = "https://app.appbind.com/register/" + accountPath + "/" + n.landingPath;
                              }

                              // Logo determination
                              let theLogo = n.logo;
                              if (theLogo == null) {
                                theLogo = n.accountTByAccountId.logo;
                              }
              
                              return (
                                <TableRow key={n.accountLandingId}>
                                  <TableCell>
                                    <Grid container alignItems="center" wrap="nowrap" spacing={1}>
                                      <Grid item>
                                        <AppLogo logoPath={theLogo} appName="App" imageHeight='24px'/>
                                      </Grid>
                                      <Grid item >
                                        <Link component="button" 
                                              variant="body2"
                                              onClick={this.goTo.bind(this, aUrl)}>
                                          {n.landingName}
                                        </Link>
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                  <TableCell align="left">{landingUrl}</TableCell>
                                  <TableCell align="left">{registerUrl}</TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Paper>
                    <div style={AppBindStyles.paginationTableFooter}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />                        
                    </div>
                  </div>
                )
              }
              return (
                <div>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </main>
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

LandingPageSearch.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(LandingPageSearch);